/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import PropTypes from 'prop-types';
import React, { memo, useEffect, useRef, useState } from 'react';
import style from '../../../../../assets/styles/testCreationStyle.module.css';
import style1 from '../../../../../assets/styles/modalStyle.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination } from '../../../common/Pagination';
import LoaderSvg from '../../../../../assets/images/loader.svg';
import {
  ADD_GROUP_LOFT_ROLE,
  ADD_SINGLE_LOFT_ROLE,
  EDIT_GROUP_LOFT_ROLE,
  EDIT_SINGLE_LOFT_ROLE,
  GET_GROUP_LOFT_ROLE,
  GET_QUESTION_TYPES,
  GET_QUESTIONBANK_LIST,
  GET_SINGLE_LOFT_ROLE,
  GET_SUBJECT_TAG,
  LOFT_GROUP_BROWSING,
  LOFT_GROUP_BROWSING_PAGINATION,
  LOFT_REPLACE_QUESTIONS,
  LOFT_SINGLE_BROWSING,
} from '../../../../../action/apiPath';
import { CallWithAuth } from '../../../../../action/apiActions';
import { Get_All_LOD, GetQuestionBankList } from '../../../../../redux/action';
import deleteId from '../../../../../assets/images/deleteId.svg';
import PreviewModal from '../../../../atoms/Modal/PreviewModal';
import QuestionListModal from '../../../../atoms/Modal/QuestionListModal';
import { openPreviewModal, closePreviewModal } from '../../../../atoms/Modal/modalHandlers';
import { editQuestionHandler } from '../../../../atoms/Modal/editHandlers';
import { handleDuplicate, openModalHelper, closeModalHelper } from '../../../../atoms/Modal/duplicateHelper';
import { handleConfirmDuplicate } from '../../../../atoms/Modal/duplicateInPreviewHelper';
import { useToast } from '../../../common/Toast';
import arrowDown from '../../../../../../src/assets/images/arrow-down.png';
import AddBrowsingModel from './AddBrowsingModel';
import QuestionsListMapping from './QuestionsListMapping';
import BrowsingPassage from './BrowsingPassage';
import TagsSearch from './TagsSearch';
import { useLocation } from 'react-router-dom';
import closeIcon from '../../../../../assets/images/closeSvgIcon.svg';
import { displayName } from 'react-quill';
// eslint-disable-next-line react/prop-types
const BrowsingQuestionLoft = memo(
  ({
    isView,
    onAdd,
    isEdit,
    testDetails,
    numberOfQuesAddedQuestion,
    isPublished,
    ruleFormat,
    ruleId,
    questionAdded,
    SetSelectIds,
    setModal,
    totalQuestion,
    selectIds,
    selectedIds,
    AddToTestPaper,
    testType,
    sectionName,
    sectionId,
    roundNo,
    setName,
    groupId,
    groupName,
    correctAnswerMarks,
    inCorrectAnswerMarks,
    testId,
    sectionRuleListing,
    handleOpenPreview,
    setBankId,
  }) => {
    const location = useLocation();
    const testAuthoringTaskId = location.state?.testAuthoringTaskId;
    const [multisubjectTaginput, setmultiSubjectTaginput] = useState('');
    const [bankLoading, setBankLoading] = useState(false);
    // _________ Free TAG STATE INITIALIZATION _________
    const [multiFreeTaginput, setmultiFreeTaginput] = useState('');
    const [multiFreeTag, setmultiFreeTag] = useState([]);
    const [multiFreeTagStatus, setmultiFreeTagStatus] = useState(false);
    const [multisubjectTag, setmultiSubjectTag] = useState([]);
    const [multisubjectTagStatus, setmultiSubjectTagStatus] = useState(false);
    // _________ AUTHIR TAG STATE INITIALIZATION _________
    const [multiAuthorTaginput, setmultiAuthorTaginput] = useState('');
    const [multiAuthorTag, setmultiAuthorTag] = useState([]);
    const [multiAuthorTagStatus, setmultiAuthorTagStatus] = useState(false);
    const [questionAccess, setQuestionAccess] = useState({});
    const [selectedQuestion, setSelectedQuestion] = useState('');
    const [isPreviewopen, setIsPreviewopen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null); // State to store dataToPass
    const [isDuplicatePreview, setIsDuplicatePreview] = useState(false); // State to store dataToPass
    const [actionId, setactionId] = useState(null);
    const [questionCategory, setQuestionCategory] = useState(false);
    // CALL GET API FOR getting TAGS
    const [resetData, setResetData] = useState(null);
    const [format, setFormat] = useState(0);
    const [organizationId, setOrganizationId] = useState(() => {
      const storedId = localStorage.getItem('selectedOrgId');
      return storedId ? Number(storedId) : null;
    });
    const [totalQuestionMatched, setTotalQuestionMatched] = useState(0);
    const toast = useToast();
    const [sortButtons, setSortButtons] = useState([
      { name: 'Author', label: 'author' },
      { name: 'Academic Year', label: 'academic_year' },
      { name: 'Created on', label: 'created_at' },
      { name: 'LOD', label: 'difficulty__level' },
    ]);
    const [onMouseHover, setOnMouseHover] = useState(false);
    const [taskLabel, setTaskLabel] = useState(testAuthoringTaskId ?? '');

    // const [multiselectedSubjectTag, setmultiSelectedSubjectTag] = useState([])
    // CALL GET API FOR getting TAGS
    const TagSubjectMultiple = async (e) => {
      setmultiSubjectTaginput(e);
      if (e.length > 2) {
        const data = await CallWithAuth('GET', GET_SUBJECT_TAG + organizationId + '/?keyword=' + e);
        if (data.status && data.res.status === 200) {
          setmultiSubjectTag(data.res.data);
          if (data.res.data.length > 0) {
            setmultiSubjectTagStatus(true);
          } else {
            setmultiSubjectTagStatus(false);
          }
        }
      } else {
        setmultiSubjectTagStatus(false);
      }
    };

    // select tags from options
    const selectSubjectTag = (e) => {
      setmultiSelectedSubjectTag((current) => [...current, e]);
      setmultiSubjectTagStatus(false);
      setmultiSubjectTaginput('');
    };
    // const [multiselectedFreeTag, setmultiSelectedFreeTag] = useState([])

    // select tags from options
    const groupDataSetterFunc = (response) => {
      const data = response.res.data.data;
      setFormat(data.format);
      setPassageNumber(1);
      setQuestionNumber(data.no_of_questions);
      setBankId(data.question_bank);
      setQuestionBankId(data.question_bank);
      setSelectedYear(data.academic_year_after ?? '');
      setSelectedYearExclude(data.academic_year_before ?? '');
      setData(response.res.data.pagination);
      setGroupRules(
        data.sub_rules.map((items, i) => ({
          lod: items.difficulty ?? '',
          question_type: items.question_type,
          primary_tags: items?.primary_tags?.map((tag) => tag?.primary_tag),
          pvalue_from: items.pvalue_from || null,
          pvalue_to: items.pvalue_to || null,
        }))
      );
      setBrowsingList(response.res.data);
      setTotalQuestionMatched(response.res.data.data.rule_total_match_questions);
      const onSubmitPayload = {
        group_id: groupId,
        section_id: sectionId,
        question_bank: data.question_bank,
        no_of_questions: data.no_of_questions,
        no_of_passages: data.no_of_passages,
        academic_year_after: data.academic_year_after,
        academic_year_before: data.academic_year_before,
        rule_unique_id: response.res.data.data.rule_unique_id,
        rule_total_lock_questions: response.res.data.data.rule_total_lock_questions,
        rule_total_match_questions: response.res.data.data.rule_total_match_questions,
        sub_rules: response.res.data.data.sub_rules.map((items, i) => ({
          question_no: items.question_no ?? i + 1,
          total_lock_questions: items.total_lock_questions,
          total_match_questions: items.total_match_questions,
          question_type: items.question_type,
          lod: items.difficulty,
          primary_tags: items?.primary_tags?.map((item) => item?.id),
          correct_answer_marks: correctAnswerMarks,
          incorrect_answer_marks: inCorrectAnswerMarks,
          pvalue_from: items.pvalue_from || null,
          pvalue_to: items.pvalue_to || null,
        })),
      };
      setGroupSavePayload(onSubmitPayload);
    };
    const singleDataSetterFunc = (response) => {
      const data = response.res.data.data;
      setFormat(data.format);
      setQuestionBankId(data.question_bank);
      setBankId(data.question_bank);
      setSelectedYear(data.academic_year_after ?? '');
      setSelectedYearExclude(data.academic_year_before ?? '');
      setQuestionTypeId(data?.question_type);
      setBrowsingList(response.res.data);
      setLod(data.difficulty_id ?? '');
      setPValue({ from: data?.pvalue_from, to: data?.pvalue_to });
      setmultiSelectedSubjectTag(data?.primary_tags?.map((tag) => tag?.primary_tag));
      setTotalQuestionMatched(data?.total_match_questions);
      // setSaveModel(response.res.data.rule_status);
      const questionsArray = response.res.data.questions.map((items, i) => items?.question_id);
      setFetchedQuestions(questionsArray);
    };
    const getGroupRules = async () => {
      setIsLoading(true);
      const url = GET_GROUP_LOFT_ROLE(ruleId, organizationId, groupId, sectionId, testId, limit, sort);
      const response = await CallWithAuth('GET', url);
      setIsLoading(false);
      if (response.status && response.res.status === 200) {
        setResetData(response);
        groupDataSetterFunc(response);
        // setSaveModel(response.res.data.rule_status);
        // const questionsArray = response.res.data.questions.results.map((items, i) => items?.question_id);
        // setFetchedQuestions(questionsArray);
        toast?.remove('all');
        toast.add(response?.res?.data?.message, 'success');
      } else {
        setTotalQuestionMatched(0);
        toast?.remove('all');
        toast.add(response?.res?.data?.error, 'error');
      }
    };
    const getSingleRules = async () => {
      setIsLoading(true);
      const url = GET_SINGLE_LOFT_ROLE(ruleId, organizationId, groupId, sectionId, testId, limit, sort);
      const response = await CallWithAuth('GET', url);
      setIsLoading(false);
      if (response.status && response.res.status === 200) {
        setResetData(response);
        singleDataSetterFunc(response);
        toast?.remove('all');
        toast.add(response?.res?.data?.message, 'success');
      } else {
        setTotalQuestionMatched(0);
        toast?.remove('all');
        toast.add(response?.res?.data?.error, 'error');
      }
    };
    useEffect(() => {
      if (ruleId) {
        if (ruleFormat === 0) {
          getSingleRules();
        }
        if (ruleFormat === 1) {
          getGroupRules();
        }
      }
    }, [ruleId]);

    // const [multiselectedAuthorTag, setmultiSelectedAuthorTag] = useState([])

    // CALL GET API FOR getting TAGS

    // Get the current year
    const currentYear = new Date().getFullYear();
    // _________ YEAR USED-> STATE INITIALIZATION _________

    // Get the current year
    // const currentYear = new Date().getFullYear();

    // Initialize state for the selected year
    // const [selectedYear, setSelectedYear] = useState(currentYear);
    // const [selectedYearExclude, setSelectedYearExclude] = useState(currentYear);

    // Create an array of years from 2000 to 20 years after the current year
    const yearOptions = [];
    for (let year = 2000; year <= currentYear + 20; year++) {
      yearOptions.push(year);
    }

    // Event handler for changing the selected year
    const handleYearChangeUsed = (e) => {
      setSelectedYear(parseInt(e.target.value, 10));
    };

    // Event handler for changing the selected year
    const handleYearChangeExclude = (e) => {
      setSelectedYearExclude(parseInt(e.target.value, 10));
    };

    // _________ PRIMARY TAG STATE INITIALIZATION _________
    const [questionId, setquestionId] = useState('');
    const [multiselectedSubjectTag, setmultiSelectedSubjectTag] = useState([]);
    const [multiselectedFreeTag, setmultiSelectedFreeTag] = useState([]);
    const [multiselectedCategoryTag, setmultiSelectedCategoryTag] = useState([]);
    const [multiselectedAuthorTag, setmultiSelectedAuthorTag] = useState([]);
    const [sort, setSort] = useState('-created_at');
    // Initialize state for the selected year
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedYearExclude, setSelectedYearExclude] = useState('');
    // _________ YEAR USED-> STATE INITIALIZATION _________

    // const [currentSort, setCurrentSort] = useState("")

    // ________ PAGINATION ________
    const [questionTypeList, setQuestionTypeList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(15);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    // _________question bank id which is top dropdown _________
    const [questionBankId, setQuestionBankId] = useState(null);
    // ________ LOD _________
    const [lod, setLod] = useState(null);
    // ________ category ________
    const [category, setCategory] = useState('');

    const [sortConfig, setSortConfig] = useState({
      field: '',
      direction: '',
      sort: '',
    });

    const handleSort = (field) => {
      setSortConfig((prevConfig) => {
        let direction, sortValue;

        if (field === 'created_at' || field === 'created_on') {
          if (prevConfig.field !== field) {
            direction = 'desc';
            sortValue = `-${field}`;
          } else {
            // Subsequent clicks toggle between asc and desc
            direction = prevConfig.direction === 'asc' ? 'desc' : 'asc';
            sortValue = direction === 'desc' ? `-${field}` : field;
          }
        } else {
          // General sorting logic for other fields
          direction = prevConfig.field === field && prevConfig.direction === 'asc' ? 'desc' : 'asc';
          sortValue = direction === 'desc' ? `-${field}` : field;
        }

        setSort(sortValue);
        setSortConfig({ field, direction, sort: sortValue });

        // Reset pagination
        setCurrentPage(1);
        setOffset(0);

        return { field, direction, sort: sortValue };
      });
    };
    const [groupSavePayload, setGroupSavePayload] = useState(null);
    const [data, setData] = useState();
    const getRotation = (field) => {
      if (field === 'created_at' || field === 'created_on') {
        // Handle 'created_at' specifically for upside-down rotation
        if (sortConfig.sort === '-created_at' || sortConfig.sort === '-created_on') return 'rotate(0deg)';
        if (sortConfig.sort === 'created_at' || sortConfig.sort === 'created_on') return 'rotate(180deg)';
      }
      if (sortConfig.field !== field) return 'rotate(0deg)';
      return sortConfig.direction === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)';
    };

    // Helper function to get icon color
    const getIconColor = (field) => {
      return sortConfig.field === field ? '#00ABFB' : '#999090';
    };

    useEffect(() => {
      const handleOrgChange = (e) => {
        setOrganizationId(e.detail.organizationId);
      };

      window.addEventListener('organizationChanged', handleOrgChange);

      return () => {
        window.removeEventListener('organizationChanged', handleOrgChange);
      };
    }, []);
    const [saveModel, setSaveModel] = useState(false);
    const [fetchedQuestions, setFetchedQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pValue, setPValue] = useState({ from: '', to: '' });

    // _________ALL question created listing data _________
    const [browsingList, setBrowsingList] = useState([]);
    const QuestionListing = async () => {
      setIsLoading(true);
      const url = LOFT_SINGLE_BROWSING + organizationId + '/';
      const payload = {
        group_id: groupId,
        section_id: sectionId,
        question_bank: questionBankId,
        primary_tags: multiselectedSubjectTag?.map((item) => item?.id) ?? null,
        lod: lod ? lod : null,
        question_type: questionTypeId,
        academic_year_after: selectedYear,
        academic_year_before: selectedYearExclude,
        test_id: testId,
        rule_id: ruleId,
        pvalue_from: pValue.from || null,
        pvalue_to: pValue.to || null,
      };
      const response = await CallWithAuth('POST', url, payload);
      setIsLoading(false);
      if (response.status && response.res.status === 200) {
        setBrowsingList(response.res.data);
        setTotalQuestionMatched(response?.res?.data?.total_match_questions);
        const questionsArray = response.res.data.questions.map((items, i) => items?.question_id);
        setFetchedQuestions(questionsArray);
        toast?.remove('all');
        toast.add(response?.res?.data?.message, 'success');
      } else {
        setTotalQuestionMatched(0);
        setFetchedQuestions([]);
        setBrowsingList([]);
        toast?.remove('all');
        toast.add(response?.res?.data?.error, 'error');
      }
    };
    const PassageListing = async () => {
      setIsLoading(true);
      const url = LOFT_GROUP_BROWSING + organizationId + '/';
      const payload = {
        rule_id: ruleId,
        test_id: testId,
        group_id: groupId,
        section_id: sectionId,
        question_bank: questionBankId,
        no_of_questions: questionNumber,
        no_of_passages: passageNumber,
        academic_year_after: selectedYear,
        academic_year_before: selectedYearExclude,
        sub_rules: groupRules.map((items, i) => ({
          question_type: items.question_type,
          lod: items.lod,
          primary_tags: items?.primary_tags?.map((item) => item?.id) ?? null,
          pvalue_from: items?.pvalue_from || null,
          pvalue_to: items?.pvalue_to || null,
        })),
      };

      const response = await CallWithAuth('POST', url, payload);
      setIsLoading(false);
      if (response.status && response.res.status === 200) {
        setBrowsingList(response.res.data);

        const onSubmitPayload = {
          group_id: groupId,
          section_id: sectionId,
          question_bank: questionBankId,
          no_of_questions: questionNumber,
          no_of_passages: passageNumber,
          academic_year_after: selectedYear,
          academic_year_before: selectedYearExclude,
          rule_unique_id: response.res.data.rule_unique_id,
          rule_total_lock_questions: response.res.data.rule_total_lock_questions,
          rule_total_match_questions: response.res.data.rule_total_match_questions,
          sub_rules: groupRules.map((items, i) => ({
            question_no: response.res.data.sub_rules[i].question_no,
            total_lock_questions: response.res.data.sub_rules[i].total_lock_questions,
            total_match_questions: response.res.data.sub_rules[i].total_match_questions,
            question_type: items.question_type,
            lod: items.lod,
            primary_tags: items?.primary_tags?.map((item) => item?.id) ?? null,
            correct_answer_marks: correctAnswerMarks,
            incorrect_answer_marks: inCorrectAnswerMarks,
            pvalue_from: response.res.data.sub_rules[i].pvalue_from || null,
            pvalue_to: response.res.data.sub_rules[i].pvalue_to || null,
          })),
        };
        setTotalQuestionMatched(response.res.data.rule_total_match_questions);
        setGroupSavePayload(onSubmitPayload);
        toast?.remove('all');
        toast.add(response?.res?.data?.message, 'success');
        const url = `${LOFT_GROUP_BROWSING_PAGINATION}${organizationId}/?test_id=${testId}&group_id=${groupId}&section_id=${sectionId}&rule_unique_id=${response.res.data.rule_unique_id}&limit=${limit}&page=${currentPage}`;
        const result = await CallWithAuth('GET', url, payload);
        setData(result.res.data);
      } else {
        setData({});
        const onSubmitPayload = {
          group_id: groupId,
          section_id: sectionId,
          question_bank: questionBankId,
          no_of_questions: questionNumber,
          no_of_passages: passageNumber,
          academic_year_after: selectedYear,
          academic_year_before: selectedYearExclude,
          rule_unique_id: response.res.data.rule_unique_id ?? '',
          rule_total_lock_questions: null,
          rule_total_match_questions: null,
          sub_rules: groupRules.map((items, i) => ({
            question_no: i + 1,
            total_lock_questions: null,
            total_match_questions: null,
            question_type: items.question_type,
            lod: items.lod,
            primary_tags: items?.primary_tags?.map((item) => item?.id) ?? null,
            correct_answer_marks: correctAnswerMarks,
            incorrect_answer_marks: inCorrectAnswerMarks,
            pvalue_from: items.pvalue_from || null,
            pvalue_to: items.pvalue_to || null,
          })),
        };
        setTotalQuestionMatched(0);
        setGroupSavePayload(onSubmitPayload);
        toast?.remove('all');
        toast.add(response?.res?.data?.error, 'error');
      }
    };

    const ReplaceQuestion = async (questionId, index) => {
      // const url = ruleId
      //   ? LOFT_REPLACE_QUESTIONS +
      //     organizationId +
      //     `/?test_id=${testId}${browsingList?.rule_unique_id ? `&group_id=${groupId}&section_id=${sectionId}&rule_unique_id=${browsingList?.rule_unique_id}` : ''}`
      //   : LOFT_REPLACE_QUESTIONS + organizationId + `/?test_id=${testId}&group_id=${groupId}&section_id=${sectionId}&rule_unique_id=${browsingList?.rule_unique_id}`;

      const url = ruleId
        ? `${LOFT_REPLACE_QUESTIONS}${organizationId}/?test_id=${testId}${
            browsingList?.rule_unique_id
              ? `&group_id=${groupId}&section_id=${sectionId}&rule_unique_id=${browsingList.rule_unique_id}`
              : ''
          }`
        : `${LOFT_REPLACE_QUESTIONS}${organizationId}/?test_id=${testId}&group_id=${groupId}&section_id=${sectionId}${
            browsingList?.rule_unique_id ? `&rule_unique_id=${browsingList.rule_unique_id}` : '&rule_unique_id=""'
          }`;

      const payload = {
        question_id: questionId,
        ids: [questionId],
      };
      if (format === 0) {
        payload.ids = browsingList.questions.map((item) => item.question_id);
      }
      const response = await CallWithAuth('POST', url, payload);
      if (response.status && response.res.status === 200) {
        if (ruleId) {
          if (ruleFormat === 0) {
            getSingleRules();
          }
          if (ruleFormat === 1) {
            // getGroupRules();
            groupSortingFn();
          }
        } else {
          if (format === 0) {
            const newData = { ...browsingList };
            newData.questions[index] = response.res.data.data;
            setBrowsingList(newData);
            const questionsArray = newData.questions.map((items, i) => items?.question_id);
            setFetchedQuestions(questionsArray);
          } else {
            groupSortingFn();
          }
        }

        toast?.remove('all');
        toast.add(response?.res?.data?.message, 'success');
      } else {
        toast?.remove('all');
        toast.add(response?.res?.data?.error, 'error');
      }
    };
    useEffect(() => {
      if (format === 0) {
        setSortButtons([
          { name: 'Author', label: 'author' },
          { name: 'Academic Year', label: 'academic_year' },
          { name: 'Created on', label: 'created_on' },
          { name: 'LOD', label: 'lod' },
        ]);
      } else {
        setSortButtons([
          { name: 'Author', label: 'created_by__first_name' },
          { name: 'Academic Year', label: 'academic_year' },
          { name: 'Created on', label: 'created_at' },
          { name: 'LOD', label: 'difficulty__level' },
        ]);
      }
    }, [format]);

    const ResetSelection = () => {
      if (ruleId) {
        if (ruleFormat === 0) {
          singleDataSetterFunc(resetData);
        } else {
          groupDataSetterFunc(resetData);
        }
      } else {
        TagSubjectMultiple('');
        setmultiSubjectTag([]);
        setLod('');
        setFormat(0);
        setPassageNumber(1);
        setQuestionNumber(null);
        setSelectedYear('');
        setSelectedYearExclude('');
        setData(null);
        setGroupRules([]);
        setBrowsingList({});
        setQuestionTypeId('');
        setTotalQuestionMatched(0);
        setmultiSelectedSubjectTag([]);
        setmultiSelectedFreeTag([]);
        setmultiSelectedAuthorTag([]);
        setOffset(0);
        setCurrentPage(1);
        setQuestionBankId('');
        setBankId('');
        setFetchedQuestions([]);
        setPValue({ from: '', to: '' });
      }
    };

    const [questionBank, setQuestionBank] = useState(null);

    const getQuestionBank = async () => {
      setBankLoading(true);
      let addTestTaskId = '';
      if (testAuthoringTaskId) {
        addTestTaskId = testAuthoringTaskId;
      } else if (testDetails?.task_label) {
        addTestTaskId = testDetails?.task_label;
      } else if (getBasicSettingData?.task_label) {
        addTestTaskId = getBasicSettingData?.task_label;
      }
      let taskId = `&task_id=${addTestTaskId}`;
      const GetData = await CallWithAuth(
        'GET',
        GET_QUESTIONBANK_LIST + organizationId + '/?is_loft=true' + '&test=true' + taskId
      );
      if (GetData.status && Array.isArray(GetData.res.data)) {
        setQuestionBank(GetData.res.data);
        setBankLoading(false);
      } else {
        toast?.remove('all');
        toast?.add(GetData?.res?.data?.error, 'error');
        setBankLoading(false);
      }
    };
    const handleModalConfirm = () => {
      if (format === 0) {
        singleApiCalling();
      } else {
        groupApiCalling();
      }
    };
    const getQuestionTypeList = async () => {
      const response = await CallWithAuth('GET', GET_QUESTION_TYPES);
      if (response.status && response.res.status === 200) {
        setQuestionTypeList(response.res.data);
      }
    };
    useEffect(() => {
      getQuestionBank();
      getQuestionTypeList();
    }, []);
    // useEffect(() => {
    //   dispatch(GetQuestionBankList(organizationId, '', ''));
    // }, []);
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(Get_All_LOD(organizationId, '', ''));
    }, []);
    const { lodList, getBasicSettingData } = useSelector((state) => state.GetAllData);

    const rowRef = useRef();
    const [groupRules, setGroupRules] = useState([
      {
        question_type: null,
        lod: null,
        primary_tags: [],
        pvalue_from: '',
        pvalue_to: '',
      },
    ]);
    const getQuestionbankStyle = () => {
      return {
        color: questionBankId ? 'black' : '#808080',
      };
    };
    const getQuestionbankSingleStyle = () => {
      return {
        color: questionTypeId ? 'black' : '#808080',
      };
    };
    const getQuestionbankGroupStyle = (i) => {
      return {
        color: groupRules[i].question_type ? 'black' : '#808080',
      };
    };
    const getLODStyle = () => {
      return {
        color: 'black',
      };
    };
    const getLODGroupStyle = (i) => {
      return {
        color: 'black',
      };
    };

    const getYearAfter = () => {
      return {
        color: selectedYear ? 'black' : '#808080',
      };
    };
    const getYearBefore = () => {
      return {
        color: selectedYearExclude ? 'black' : '#808080',
      };
    };

    const handleCloseModal = () => {
      closePreviewModal(setIsPreviewopen, setIsDuplicatePreview, setIsModalOpen);
    };

    const handleSaveRule = () => {
      if (!browsingList.rule_status) {
        setSaveModel(true);
        return false;
      }
      if (format === 0) {
        singleApiCalling();
      } else {
        groupApiCalling();
      }
    };
    const singleApiCalling = async () => {
      const payload = {
        group_id: groupId,
        section_id: sectionId,
        question_bank: questionBankId,
        primary_tags: multiselectedSubjectTag?.map((item) => item?.id) ?? null,
        lod: lod ? lod : null,
        question_type: questionTypeId,
        academic_year_after: selectedYear,
        academic_year_before: selectedYearExclude,
        correct_answer_marks: correctAnswerMarks,
        incorrect_answer_marks: inCorrectAnswerMarks,
        pvalue_from: pValue.from || null,
        pvalue_to: pValue.to || null,
        total_lock_questions: browsingList?.data?.total_lock_questions ?? browsingList?.total_lock_questions,
        total_match_questions: browsingList?.data?.total_match_questions ?? browsingList?.total_match_questions,
        org_id: organizationId,
        questions: fetchedQuestions,
      };
      const url = ruleId
        ? EDIT_SINGLE_LOFT_ROLE(testId, ruleId, organizationId)
        : ADD_SINGLE_LOFT_ROLE(organizationId, testId);
      const response = await CallWithAuth(ruleId ? 'PUT' : 'POST', url, payload);

      if (response.status && response.res.status === 200) {
        setModal(false);
        toast?.remove('all');
        toast?.add(response?.res?.data?.message, 'success');
        sectionRuleListing();
      } else {
        toast?.remove('all');
        toast?.add(response?.res?.data?.error, 'error');
      }
    };

    const groupApiCalling = async () => {
      const url = ruleId
        ? EDIT_GROUP_LOFT_ROLE(testId, ruleId, organizationId)
        : ADD_GROUP_LOFT_ROLE(organizationId, testId);
      const response = await CallWithAuth(ruleId ? 'PUT' : 'POST', url, groupSavePayload);

      if (response.status && response.res.status === 200) {
        setModal(false);
        toast?.remove('all');
        toast?.add(response?.res?.data?.message, 'success');
        sectionRuleListing();
      } else {
        toast?.remove('all');
        toast?.add(response?.res?.data?.error, 'error');
      }
    };
    const onConfirmDuplicate = (
      questionBankId,
      questionId,
      questionCategory = null, // Default to null or any appropriate value
      QuestionListing = () => Promise.resolve(true), // Default to a no-op function
      MyQuestionListing = () => Promise.resolve(true) // Default to a no-op function
    ) => {
      handleConfirmDuplicate(
        questionBankId,
        questionId,
        setIsModalOpen,
        setIsPreviewopen,
        setIsDuplicatePreview,
        setactionId,
        toast,
        questionCategory,
        QuestionListing,
        MyQuestionListing
      );
    };

    const closeModal = () => {
      closeModalHelper(setIsModalOpen, setModalData, setIsDuplicatePreview);
    };

    const handleEdit = async (items) => {
      await editQuestionHandler(items, setIsPreviewopen, openModalMedium, setQuestionItem, navigate);
    };
    const [questionTypeId, setQuestionTypeId] = useState(null);

    function sortArray(arr, sortObject) {
      const { field, direction } = sortObject;
      const result = arr?.sort((a, b) => {
        if (!a[field] || !b[field]) return 0; // Handle missing fields gracefully

        if (field === 'created_on' || field === 'academic_year') {
          const valueA = new Date(a[field]);
          const valueB = new Date(b[field]);

          if (valueA < valueB) return direction === 'asc' ? -1 : 1;
          if (valueA > valueB) return direction === 'asc' ? 1 : -1;
          return 0;
        } else {
          const valueA = a[field].toString().toLowerCase();
          const valueB = b[field].toString().toLowerCase();

          if (valueA < valueB) return direction === 'asc' ? -1 : 1;
          if (valueA > valueB) return direction === 'asc' ? 1 : -1;
          return 0;
        }
      });
      return result;
    }
    const [passageNumber, setPassageNumber] = useState(1);
    const [questionNumber, setQuestionNumber] = useState(null);
    const groupSortingFn = async () => {
      const url =
        groupSavePayload?.rule_unique_id !== ''
          ? `${LOFT_GROUP_BROWSING_PAGINATION}${organizationId}/?test_id=${testId}&group_id=${groupId}&section_id=${sectionId}&rule_unique_id=${groupSavePayload?.rule_unique_id}&limit=${limit}&page=${currentPage}&sort=${sort}`
          : GET_GROUP_LOFT_ROLE(ruleId, organizationId, groupId, sectionId, testId, limit, sort);
      const result = await CallWithAuth('GET', url);
      if (result.status && result.res.status === 200) {
        groupSavePayload?.rule_unique_id !== '' ? setData(result.res.data) : setData(result.res.data.pagination);
      } else {
        setData({});
      }
    };
    useEffect(() => {
      if (format === 0) {
        const currentList = { ...browsingList };
        const sortedList = currentList.questions && sortArray(currentList.questions, sortConfig);
        setBrowsingList({ ...currentList, questions: sortedList });
      }
      if (format === 1) {
        if (groupSavePayload) {
          groupSortingFn();
        }
      }
    }, [sortConfig, sort, format, currentPage]);
    const removeSubjectTag = (itemToRemove) => {
      setmultiSelectedSubjectTag((current) => current.filter((item) => item?.id !== itemToRemove?.id));
    };
    return (
      <>
        <div className={style1.filterModal}>
          <div className={style1.overlay}></div>
          <div className={style1.center_div_larger} style={{ overflow: 'hidden' }}>
            <div className={`${style.test_creation_form} ${style.test_creation_loft}`}>
              <div className={`${style.filterContainer} ${style.filterContainer_new}`}>
                <div style={{ paddingLeft: '15px', paddingRight: '10px' }} className={style.test_top_content_table}>
                  <div className={style.leftItems}>
                    <p style={{ fontWeight: '600', fontSize: '18px', margin: '0px', marginBottom: '10px' }}>
                      Browsing questions for {sectionName || ''}
                    </p>
                    <div style={{ fontSize: '13px', marginBottom: '12px' }} className={style.handleAttempt}>
                      <span>{numberOfQuesAddedQuestion ?? 0} </span>
                      <span style={{ color: 'lightgray', paddingRight: '5px' }}>/{totalQuestion}</span>
                      <span>Questions already added</span>
                    </div>
                  </div>
                  <div className={style.table_filter_right_options}>
                    <svg
                      onClick={() => setModal(false)}
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.35352 6.34375L17.684 17.6575"
                        stroke="#212529"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6.35216 17.6575L17.6826 6.34375"
                        stroke="#212529"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>

                <div className={style.masterfilterCreation} style={{ height: '80vh' }}>
                  <div className={style.filterCreationArea} style={{ height: '100%' }}>
                    {/* filters  */}
                    <div className={style.sectionContainer}>
                      <section className={style.workArea1}>
                        <div className={`${style.tags} ${style.width_60} ${style.tags_new}`}>
                          <div className={`${style.subject} ${style.sublectLabel}`}>
                            <p>
                              Question Bank <b className={style.red_mendantory}>*</b>{' '}
                            </p>
                            <div className={`${style.header_drop} ${style.header_drop_background}`}>
                              <select
                                disabled={isView}
                                name="question"
                                id="question"
                                style={getQuestionbankStyle()}
                                className={style.custom_select}
                                value={questionBankId}
                                onChange={(e) => {
                                  setQuestionBankId(Number(e.target.value));
                                  setBankId(Number(e.target.value));
                                }}
                              >
                                <option value={null}>Select question bank </option>
                                {questionBank?.map((items, i) => (
                                  <option key={i} value={items.id}>
                                    {items.name}
                                  </option>
                                ))}
                              </select>
                              {bankLoading && (
                                <img
                                  style={{ position: 'relative', top: '9px', left: '9px' }}
                                  src={LoaderSvg}
                                  alt="Custom Arrow"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className={`${style.tags} ${style.width_60}`}>
                          <div className={style.subject}>
                            <p>
                              Choose format <b className={style.red_mendantory}>*</b>{' '}
                            </p>
                            <div
                              style={{ gap: '5px' }}
                              className={`${style.randmizeQue} ${style.custom_input_container} ${style.custom_input_container_width}`}
                            >
                              <input
                                disabled={isView || ruleId}
                                type="radio"
                                id="randomizeQuestionsYes"
                                className={`${style.custom_radio} ${style.custom_radio_width}`}
                                checked={format === 0}
                                onChange={() => {
                                  setFormat(0);
                                  setTotalQuestionMatched(0);
                                  setBrowsingList({});
                                  setData({});
                                }}
                              />{' '}
                              <label htmlFor="randomizeQuestionsYes">Single Question</label>
                              <input
                                type="radio"
                                id="randomizeQuestionsNo"
                                disabled={isView || ruleId}
                                className={`${style.custom_radio} ${style.custom_radio_width}`}
                                checked={format === 1}
                                onChange={() => {
                                  setFormat(1);
                                  setTotalQuestionMatched(0);
                                  setBrowsingList({});
                                  setData({});
                                }}
                              />{' '}
                              <label htmlFor="randomizeQuestionsNo">Grouped Questions</label>
                            </div>
                          </div>
                        </div>
                        {/* subject tag  */}
                        {format === 0 && (
                          <>
                            <div className={`${style.tags_container} ${style.tags_container_width}`}>
                              <div className={`${style.tags} ${style.width_60}`} style={{ width: '60%' }}>
                                <div className={`${style.subject} ${style.sublectLabel}`}>
                                  <p>
                                    Question Type <b className={style.red_mendantory}>*</b>{' '}
                                  </p>
                                  <div className={`${style.header_drop} ${style.header_drop_background_width}`}>
                                    <select
                                      disabled={isView}
                                      value={questionTypeId}
                                      name="question"
                                      id="question"
                                      style={getQuestionbankSingleStyle()}
                                      className={style.custom_select}
                                      onChange={(e) => setQuestionTypeId(Number(e.target.value))}
                                    >
                                      <option value={null}>{'Select question type'}</option>
                                      {questionTypeList?.map((items, i) => (
                                        <option key={i} value={items.id}>
                                          {items.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className={`${style.tags} ${style.tags_new}`}>
                                <div className={`${style.subject} ${style.sublectLabel}`}>
                                  <p>
                                    Area | Topic | Subtopic <b className={style.red_mendantory}>*</b>{' '}
                                  </p>
                                  <div className={style.search_listing} style={{ height: 'auto' }}>
                                    <div className={style.tag_icons}>
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18Z"
                                          stroke="#212529"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M18.2598 19.2592L16.1406 16.8594"
                                          stroke="#212529"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      Tags
                                    </div>
                                    <div className={style.input_search} ref={rowRef} style={{ display: 'flex' }}>
                                      <div className={style.tag_icons} style={{ paddingRight: '0' }}>
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect width="20" height="20" rx="4" fill="#272727" />
                                          <path
                                            d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                                            fill="white"
                                          />
                                        </svg>
                                      </div>
                                      <input
                                        disabled={isView}
                                        type="search"
                                        id="searchInput"
                                        placeholder="Search tags"
                                        value={multisubjectTaginput}
                                        autoComplete="off"
                                        list="autocompleteoff"
                                        onChange={(e) => TagSubjectMultiple(e.target.value)}
                                        onBlur={() => {
                                          if (!onMouseHover) {
                                            TagSubjectMultiple('');
                                            //setmultiSubjectTag([]);
                                          }
                                        }}
                                        style={{ margin: '5px', padding: '10px', width: '97%' }}
                                      />

                                      {multisubjectTagStatus ? (
                                        <div
                                          className={style.list_input_primary}
                                          onMouseOver={() => {
                                            setOnMouseHover(true);
                                          }}
                                          onMouseLeave={() => {
                                            setOnMouseHover(false);
                                          }}
                                        >
                                          {multisubjectTag
                                            ?.filter(
                                              (item) =>
                                                !multiselectedSubjectTag.some((filterItem) => item.id === filterItem.id)
                                            )
                                            .map((items, i) => (
                                              <>
                                                <div
                                                  onClick={() => {
                                                    selectSubjectTag(items);
                                                    setOnMouseHover(false);
                                                  }}
                                                >
                                                  <span>
                                                    {items.subject} | {items.area} | {items.topic} | {items.subtopic}{' '}
                                                  </span>
                                                </div>
                                              </>
                                            ))}
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {multiselectedSubjectTag?.map((items, i) => (
                                  <div
                                    className={`${style.subjectWrap} ${style.subjectWrapPosition} ${style1.slelectedItems}`}
                                    key={items + i}
                                  >
                                    <span
                                      title={`${items.subject} | ${items.area} | ${items.topic} | ${items.subtopic} `}
                                      className={`${style.selected_tags} ${style.selected_tags_bg_reomve}`}
                                      style={{ width: '94%' }}
                                    >
                                      {items?.subject} | {items?.area} | {items?.topic} | {items?.subtopic}
                                    </span>
                                    <button className={style1.crossbutton} onClick={() => removeSubjectTag(items)}>
                                      <img src={closeIcon} alt="Close" />
                                    </button>
                                  </div>
                                ))}
                              </div>
                              <div className={`${style.tags} ${style.p_valueWrap}`}>
                                <div className={style.subject}>
                                  <p>P-Value Range</p>
                                  <div className={`${style.inputValuewrap}`}>
                                    <input
                                      disabled={isView}
                                      onKeyDown={(e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                          e.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      autoComplete="off"
                                      type="text"
                                      id="pvalueFrom"
                                      placeholder="From"
                                      value={pValue.from}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        // Allow clearing the input
                                        if (value === '') {
                                          setPValue({ ...pValue, from: '' });
                                          return;
                                        }
                                        // Allow optional '-' at the start, digits, optional decimal with any length
                                        const validNumberRegex = /^-?\d*(\.\d*)?$/;
                                        if (validNumberRegex.test(value)) {
                                          setPValue({ ...pValue, from: value });
                                        }
                                      }}
                                      onBlur={(e) => {
                                        const parsed = parseFloat(pValue.from);
                                        if (!isNaN(parsed)) {
                                          setPValue({ ...pValue, from: parsed });
                                        } else {
                                          setPValue({ ...pValue, from: '' });
                                        }
                                      }}
                                      className={style.inputTextFrom}
                                    />
                                    <input
                                      disabled={isView}
                                      onKeyDown={(e) => {
                                        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                          event.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      autoComplete="off"
                                      type="text"
                                      id="pvalueTO"
                                      placeholder="To"
                                      value={pValue.to}
                                      min={0}
                                      max={999}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        // Allow clearing the input
                                        if (value === '') {
                                          setPValue({ ...pValue, to: '' });
                                          return;
                                        }
                                        // Allow optional '-' at the start, digits, optional decimal with any length
                                        const validNumberRegex = /^-?\d*(\.\d*)?$/;
                                        if (validNumberRegex.test(value)) {
                                          setPValue({ ...pValue, to: value });
                                        }
                                      }}
                                      onBlur={(e) => {
                                        const parsed = parseFloat(pValue.to);
                                        if (!isNaN(parsed)) {
                                          setPValue({ ...pValue, to: parsed });
                                        } else {
                                          setPValue({ ...pValue, to: '' });
                                        }
                                      }}
                                      className={style.inputTextTo}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* category and tag  */}
                            <div
                              style={{ width: '116% !important' }}
                              className={`${style.drop} ${style.tags_container} ${style.tags_container_width_new}`}
                            >
                              <div className={`${style.tags} `} style={{ width: '40%' }}>
                                <div className={`${style.subject} ${style.sublectLabel}`}>
                                  <p>
                                    Level of Difficulty <b className={style.red_mendantory}>*</b>{' '}
                                  </p>
                                  <div className={`${style.header_drop} ${style.header_drop_background_third}`}>
                                    <select
                                      disabled={isView}
                                      name="question"
                                      id="question"
                                      value={lod}
                                      style={getLODStyle()}
                                      className={style.custom_select}
                                      onChange={(e) => {
                                        setLod(Number(e.target.value));
                                      }}
                                    >
                                      <option>Any</option>
                                      {structuredClone(lodList)?.map((items, i) => (
                                        <option key={i} value={items.id}>
                                          {items.level}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div
                                className={style.drop_item}
                                style={{ position: 'relative', right: '10px', top: '4px' }}
                              >
                                <div className={`${style.subject} ${style.sublectLabel}`}>
                                  <p className={style.subjectLabel}>Include Question Used in or After </p>
                                  <select
                                    disabled={isView}
                                    name="question"
                                    id="question"
                                    style={getYearAfter()}
                                    className={`${style.header_drop_filter} ${style.custom_select}`}
                                    value={selectedYear}
                                    onChange={handleYearChangeUsed}
                                  >
                                    <option value={null}>Select year</option>
                                    {yearOptions.map((year) => (
                                      <option key={year} value={year}>
                                        {year}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className={style.drop_item} style={{ position: 'relative', top: '4px' }}>
                                <div className={style.subject}>
                                  <p className={style.subjectLabel}>Include Question Used in or Before </p>
                                  <select
                                    disabled={isView}
                                    name="question"
                                    id="question"
                                    style={getYearBefore()}
                                    className={`${style.header_drop_filter} ${style.custom_select}`}
                                    value={selectedYearExclude}
                                    onChange={handleYearChangeExclude}
                                  >
                                    <option value={null}>Select year</option>
                                    {yearOptions.map((year) => (
                                      <option key={year} value={year}>
                                        {year}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {format === 1 && (
                          <>
                            <div className={`${style.tags_container} `}>
                              <div style={{ width: '29% !important' }} className={`${style.tags}`}>
                                <div className={style.subject}>
                                  <p>
                                    No. of Passages <b className={style.red_mendantory}>*</b>{' '}
                                  </p>
                                  <div className={`${style.header_drop} ${style.header_drop_background_width}`}>
                                    <input
                                      onKeyDown={(e) => {
                                        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                          event.preventDefault();
                                        }
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      autoComplete="off"
                                      disabled={true}
                                      name="question"
                                      id="question"
                                      className={style.inputTextStyle}
                                      value={1}
                                      type="number"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={`${style.tags} ${style.tags_new}`}>
                                <div className={style.subject}>
                                  <p>
                                    No. of Questions <b className={style.red_mendantory}>*</b>{' '}
                                  </p>
                                  <input
                                    onKeyDown={(e) => {
                                      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                        event.preventDefault();
                                      }
                                    }}
                                    disabled={isView}
                                    name="question1"
                                    id="question1"
                                    className={style.inputTextStyle}
                                    value={questionNumber}
                                    autoComplete="off"
                                    onWheel={(e) => e.target.blur()}
                                    type="number"
                                    min={1}
                                    onBlur={(e) => {
                                      const data = [...groupRules];
                                      if (+e.target.value > data.length) {
                                        // Add new empty objects
                                        while (data.length < +e.target.value) {
                                          data.push({
                                            question_type: null,
                                            lod: null,
                                            primary_tags: [],
                                            pvalue_from: '',
                                            pvalue_to: '',
                                          });
                                        }
                                      } else if (+e.target.value < data.length) {
                                        // Remove extra objects
                                        data.length = +e.target.value;
                                      }

                                      setGroupRules(data);
                                    }}
                                    onChange={(e) => {
                                      if (e.target.value == '') {
                                        setQuestionNumber(e.target.value);
                                      } else {
                                        let newValue = e.target.value;

                                        // Remove non-numeric characters
                                        newValue = newValue.replace(/\D/g, '');

                                        // Ensure it's an integer and not negative
                                        if (newValue === '' || parseInt(newValue, 10) >= 0) {
                                          setQuestionNumber(+newValue);
                                        }
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* category and tag  */}
                            <div
                              style={{ width: '116% ' }}
                              className={`${style.drop} ${style.tags_container} ${style.tags_container_width_new}`}
                            >
                              <div style={{ width: '22% !important' }} className={style.drop_item}>
                                <div className={style.subject}>
                                  <p className={style.subjectLabel}>Include Question Used in or After </p>
                                  <select
                                    disabled={isView}
                                    name="question"
                                    id="question"
                                    className={`${style.header_drop_filter} ${style.custom_select}`}
                                    style={getYearAfter()}
                                    value={selectedYear}
                                    onChange={handleYearChangeUsed}
                                  >
                                    <option value={null}>Select year</option>
                                    {yearOptions.map((year) => (
                                      <option key={year} value={year}>
                                        {year}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div style={{ width: '22% !important' }} className={style.drop_item}>
                                <div className={style.subject}>
                                  <p className={style.subjectLabel}>Include Question Used in or Before </p>
                                  <select
                                    disabled={isView}
                                    name="question"
                                    id="question"
                                    style={getYearBefore()}
                                    className={`${style.header_drop_filter} ${style.custom_select}`}
                                    value={selectedYearExclude}
                                    onChange={handleYearChangeExclude}
                                  >
                                    <option value={null}>Select year</option>
                                    {yearOptions.map((year) => (
                                      <option key={year} value={year}>
                                        {year}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            {groupRules?.map((item, i) => (
                              <div>
                                <p style={{ margin: '5px 0px', fontWeight: '500' }}>Question {i + 1}</p>
                                <div style={{ display: 'flex', gap: '24px' }} className={`${style.questionTags}`}>
                                  <div style={{ marginLeft: 0, width: '30%' }} className={style.subject}>
                                    <p style={{ margin: '10px 0px 15px' }} className={style.subjectLabel}>
                                      Question Type <b className={style.red_mendantory}>*</b>{' '}
                                    </p>
                                    <div className={`${style.header_drop} ${style.header_drop_background_width}`}>
                                      <select
                                        disabled={isView}
                                        value={item?.question_type}
                                        name="question"
                                        id="question"
                                        style={getQuestionbankGroupStyle(i)}
                                        className={style.custom_select}
                                        onChange={(e) => {
                                          const data = [...groupRules];
                                          data[i].question_type = Number(e.target.value);
                                          setGroupRules(data);
                                        }}
                                      >
                                        <option value={null}>{'Select question type'}</option>
                                        {questionTypeList?.map((items, i) => (
                                          <option key={i} value={items.id}>
                                            {items.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <TagsSearch
                                    disabled={isView}
                                    ref={rowRef}
                                    index={i}
                                    groupRules={groupRules}
                                    setGroupRules={setGroupRules}
                                    style={style}
                                  />

                                  <div style={{ width: '47%', marginTop: '0px' }} className={`${style.tags}`}>
                                    <div className={style.subject}>
                                      <p>P-Value Range</p>
                                      <input
                                        className={style.inputTextFrom}
                                        disabled={isView}
                                        onKeyDown={(e) => {
                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                          }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        autoComplete="off"
                                        type="text"
                                        id="pvalueFrom"
                                        placeholder="From"
                                        value={item.pvalue_from}
                                        min={0}
                                        max={999}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          const data = [...groupRules];
                                          // Allow clearing the input
                                          if (value === '') {
                                            data[i].pvalue_from = '';
                                            setGroupRules(data);
                                            return;
                                          }
                                          // Allow optional '-' at the start, digits, optional decimal with any length
                                          const validNumberRegex = /^-?\d*(\.\d*)?$/;
                                          if (validNumberRegex.test(value)) {
                                            data[i].pvalue_from = value;
                                            setGroupRules(data);
                                          }
                                        }}
                                        onBlur={(e) => {
                                          const data = [...groupRules];
                                          const parsed = parseFloat(data[i].pvalue_from);
                                          if (!isNaN(parsed)) {
                                            data[i].pvalue_from = parsed;
                                          } else {
                                            data[i].pvalue_from = '';
                                          }
                                          setGroupRules(data);
                                        }}
                                      />
                                      <input
                                        className={style.inputTextFrom}
                                        // disabled={isView || isPublished}
                                        disabled={true}
                                        style={{ marginLeft: 10 }}
                                        onKeyDown={(e) => {
                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                          }
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        autoComplete="off"
                                        type="text"
                                        id="pvalueFrom"
                                        placeholder="To"
                                        value={item.pvalue_to}
                                        min={0}
                                        max={999}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          const data = [...groupRules];
                                          // Allow clearing the input
                                          if (value === '') {
                                            data[i].pvalue_to = '';
                                            setGroupRules(data);
                                            return;
                                          }
                                          // Allow optional '-' at the start, digits, optional decimal with any length
                                          const validNumberRegex = /^-?\d*(\.\d*)?$/;
                                          if (validNumberRegex.test(value)) {
                                            data[i].pvalue_to = value;
                                            setGroupRules(data);
                                          }
                                        }}
                                        onBlur={(e) => {
                                          const data = [...groupRules];
                                          const parsed = parseFloat(data[i].pvalue_to);
                                          if (!isNaN(parsed)) {
                                            data[i].pvalue_to = parsed;
                                          } else {
                                            data[i].pvalue_to = '';
                                          }
                                          setGroupRules(data);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className={`${style.tags} ${style.tags_new}`} style={{ margin: '0px' }}>
                                  <div
                                    className={`${style.tags} ${style.tags_latest}`}
                                    style={{ margin: '0px', marginBottom: '15px' }}
                                  >
                                    <div className={`${style.subject} `} style={{ width: '65%' }}>
                                      <p style={{ marginTop: '5px' }}>
                                        Level of Difficulty <b className={style.red_mendantory}>*</b>{' '}
                                      </p>
                                      <div className={`${style.header_drop} ${style.header_drop_background_third}`}>
                                        <select
                                          disabled={isView}
                                          name="question"
                                          id="question"
                                          value={item?.lod}
                                          style={getLODGroupStyle(i)}
                                          className={style.custom_select}
                                          onChange={(e) => {
                                            const data = [...groupRules];
                                            data[i].lod = Number(e.target.value);
                                            setGroupRules(data);
                                          }}
                                        >
                                          <option value={null}>Any</option>
                                          {lodList?.map((items, i) => (
                                            <option key={i} value={items.id}>
                                              {items.level}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </section>
                    </div>
                    {/* button  */}
                    <div style={{ paddingLeft: '7px' }} className={`${style.performBT} ${style.performBT_new}`}>
                      <button
                        style={{ cursor: isView ? 'not-allowed' : 'pointer' }}
                        disabled={isView}
                        className={` ${style.btOne} ${style.common}`}
                        onClick={() => ResetSelection()}
                      >
                        Reset Selection
                      </button>
                      <button
                        style={{ cursor: isView ? 'not-allowed' : 'pointer' }}
                        disabled={isView || isLoading}
                        className={` ${style.btTwo} ${style.common}`}
                        onClick={() => {
                          setBrowsingList({});
                          setData({});
                          setTotalQuestionMatched(0);
                          format === 0 ? QuestionListing() : PassageListing();
                        }}
                      >
                        {isLoading ? 'Loading...' : 'Apply Selected Rule'}
                      </button>
                      {totalQuestionMatched > 0 && (
                        <span className={style.resultChips}>
                          <svg
                            style={{ position: 'relative', top: '7px' }}
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 22.5C17.5 22.5 22 18 22 12.5C22 7 17.5 2.5 12 2.5C6.5 2.5 2 7 2 12.5C2 18 6.5 22.5 12 22.5Z"
                              fill="url(#paint0_linear_15846_48296)"
                            />
                            <path
                              d="M7.75 12.5019L10.58 15.3319L16.25 9.67188"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_15846_48296"
                                x1="22"
                                y1="2.5"
                                x2="7.89816"
                                y2="18.9928"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#9BF763" />
                                <stop offset="1" stopColor="#25AB5B" />
                              </linearGradient>
                            </defs>
                          </svg>
                          &nbsp;{totalQuestionMatched} such questions found from system!
                        </span>
                      )}
                    </div>
                    {/*  ________________________________ question ________________________________ */}
                    {(browsingList?.questions?.length > 0 || data?.results?.length > 0) && (
                      <>
                        {' '}
                        <div className={`${style.headerBank} ${style.title_border}`}>
                          <h4 style={{ fontWeight: '500', margin: '0px', fontSize: '18px' }}>Question List</h4>
                        </div>
                        <div className={style.LoftsortWrap}>
                          {sortButtons.map((item) => (
                            <span
                              className={` ${style.second} ${style.pointer}  ${style.sortChips} ${style.sortChips_new}`}
                            >
                              {' '}
                              <span>{item.name}</span>
                              <svg
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSort(item.label);
                                }}
                                width="19"
                                height="12"
                                viewBox="0 0 19 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  marginLeft: '6px',
                                  transform: getRotation(item.label),
                                  transition: 'transform 0.3s ease',
                                }}
                              >
                                <path
                                  d="M15.2308 2.36369L15.2308 11.3077C15.2308 11.69 14.9208 12 14.5385 12C14.1561 12 13.8462 11.69 13.8462 11.3077L13.8462 2.36369L11.7972 4.41261C11.5269 4.68298 11.0885 4.68298 10.8182 4.41261C10.5478 4.14225 10.5478 3.7039 10.8182 3.43354L14.0489 0.202771C14.3193 -0.0675907 14.7576 -0.0675907 15.028 0.202771L18.2588 3.43354C18.5291 3.7039 18.5291 4.14225 18.2588 4.41261C17.9884 4.68298 17.5501 4.68298 17.2797 4.41261L15.2308 2.36369Z"
                                  fill={getIconColor(item.label)}
                                />
                                <path
                                  d="M0 10.8462C0 11.2285 0.309957 11.5385 0.692308 11.5385H9.46154C9.84389 11.5385 10.1538 11.2285 10.1538 10.8462C10.1538 10.4638 9.84389 10.1538 9.46154 10.1538H0.692308C0.309957 10.1538 0 10.4638 0 10.8462Z"
                                  fill={getIconColor(item.label)}
                                />
                                <path
                                  d="M0 6.23077C0 6.61312 0.309957 6.92308 0.692308 6.92308H5.76923C6.15158 6.92308 6.46154 6.61312 6.46154 6.23077C6.46154 5.84842 6.15158 5.53846 5.76923 5.53846H0.692308C0.309957 5.53846 0 5.84842 0 6.23077Z"
                                  fill={getIconColor(item.label)}
                                />
                                <path
                                  d="M0 1.61538C0 1.99774 0.309957 2.30769 0.692308 2.30769H3.92308C4.30543 2.30769 4.61538 1.99774 4.61538 1.61538C4.61538 1.23303 4.30543 0.923077 3.92308 0.923077H0.692308C0.309957 0.923077 0 1.23303 0 1.61538Z"
                                  fill={getIconColor(item.label)}
                                />
                              </svg>
                            </span>
                          ))}
                        </div>
                        <div className={`${style.questionBank} ${style.questionBankNoBorder}`}>
                          {/* ________________ question ________________  */}
                          <div className={style.sub_head_content_table}>
                            {format === 0
                              ? browsingList?.questions?.map((items, i) => (
                                  <QuestionsListMapping
                                    style={style}
                                    items={items}
                                    ReplaceQuestion={ReplaceQuestion}
                                    isReplaceEnabled={onAdd || (isEdit && testDetails?.remove_rules)}
                                    index={i}
                                    handleOpenPreview={handleOpenPreview}
                                  />
                                ))
                              : data?.results?.map((items, i) => (
                                  <BrowsingPassage
                                    index={i}
                                    data={data}
                                    setData={setData}
                                    style={style}
                                    items={items}
                                    ReplaceQuestion={ReplaceQuestion}
                                    isReplaceEnabled={onAdd || (isEdit && testDetails?.remove_rules)}
                                    handleOpenPreview={handleOpenPreview}
                                  />
                                ))}
                          </div>

                          {/* ________________ footer ________________ */}
                          {data?.count >= limit && (
                            <footer className={style.sectionFooter} style={{ marginTop: '20px' }}>
                              <div className={style.testPaperPagination}>
                                <Pagination
                                  currentPage={currentPage}
                                  setCurrentPage={setCurrentPage}
                                  limit={limit}
                                  totalCount={data?.count}
                                  offset={offset}
                                  setOffset={setOffset}
                                />
                              </div>
                            </footer>
                          )}

                          {/*______________________________ PAGINATION ______________________________  */}
                          {!isView && (
                            <div className={style.footerBtnContainer}>
                              <button onClick={() => setModal(false)} className={style.cancelBtnStyle}>
                                Cancel
                              </button>
                              <button onClick={handleSaveRule} className={style.saveBtnStyle}>
                                Save & Add Rule
                              </button>
                            </div>
                          )}
                          {/*______________________________ PAGINATION ______________________________  */}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {saveModel && (
          <AddBrowsingModel
            onClose={() => setSaveModel(false)}
            onConfirm={handleModalConfirm}
            numOfQuestions={browsingList?.questions?.count}
          />
        )}
      </>
    );
  }
);

BrowsingQuestionLoft.propTypes = {
  displayName: 'BrowsingQuestionLoft',
  AddToTestPaper: PropTypes.func,
  SetSelectIds: PropTypes.func,
  correctAnswerMarks: PropTypes.any,
  groupId: PropTypes.any,
  groupName: PropTypes.any,
  inCorrectAnswerMarks: PropTypes.any,
  isEdit: PropTypes.any,
  isPublished: PropTypes.any,
  isView: PropTypes.any,
  numberOfQuesAddedQuestion: PropTypes.number,
  onAdd: PropTypes.any,
  questionAdded: PropTypes.any,
  roundNo: PropTypes.any,
  rule: PropTypes.any,
  ruleFormat: PropTypes.number,
  ruleId: PropTypes.any,
  sectionId: PropTypes.any,
  sectionName: PropTypes.string,
  sectionRuleListing: PropTypes.func,
  selectIds: PropTypes.shape({
    filter: PropTypes.func,
    includes: PropTypes.func,
    length: PropTypes.number,
    map: PropTypes.func,
  }),
  selectedIds: PropTypes.shape({
    map: PropTypes.func,
  }),
  setModal: PropTypes.func,
  setName: PropTypes.any,
  testDetails: PropTypes.any,
  testId: PropTypes.any,
  testType: PropTypes.number,
  totalQuestion: PropTypes.any,
};

export default BrowsingQuestionLoft;
